import React from 'react'
import Hero from '../components/Hero'

export default function Error() {
    return (
<Hero hero="carsHero2"/>
    )
}
